import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { flushQueue, prefetchOffline, registerSW } from "@/lib/offline";

export function useOfflineSync(onSynced) {
  const onSyncedRef = useRef(onSynced);
  onSyncedRef.current = onSynced;

  useEffect(() => {
    registerSW();
    const sync = async () => {
      const sent = await flushQueue();
      if (sent) {
        toast.success(`${sent} leçon(s) hors ligne envoyée(s)`);
        onSyncedRef.current?.();
      }
      prefetchOffline();
    };
    sync();
    window.addEventListener("online", sync);
    return () => window.removeEventListener("online", sync);
  }, []);
}
